
  import Vue from "vue";
  import pedigreeService from "@/services/portal/pedigreeService";
  import { UserInfo } from "@/types/User";
  import ReportViewer from "@/components/Admin/Reports/ReportViewer.vue";
  import { PaginationOptions, PaginatedResponse } from "@/types/Pagination";
  import lookupsService from "@/services/lookupsService";
import { debounce } from "throttle-debounce";
import { formatDateISO } from "@/helpers/date-utils";
  
  export default Vue.extend({
    name: "MyPedigrees",
    components: {
        ReportViewer
    },
    props: {
      dogId: { type: String },
    },
    data: function() {
      return {
        loading: false,
        isError: false,
        errorMessage: "",
        Report_Name: '',
        Report_URL: '',
        openedDogId: null as any,
        openedReportType: null as any,
        exportsSettings: {},
        showReportDialog: false,
        paginatedResponse: {} as PaginatedResponse<object>,
        searchParams: {
          dogId: this.$props.dogId,
          dogName: "",    
          includeInactive: false,      
        },
        options: { itemsPerPage: -1 } as PaginationOptions,   
        headers: [
          { text: "Report type", align: "left", value: "reportTypeName", width: "100px", sortable: false },
          { text: "Dog ID#", align: "left", value: "dogId", width: "100px", sortable: false },
          { text: "Dog Name", align: "left", value: "dogName", width: "200px", sortable: false },
          { text: "Access dates", align: "left", value: "accessStartsAt", width: "200px", sortable: false },
          { text: "", align: "left", value: "actionButton", width: "100px", sortable: false },
        ],
      };
    },
    created: function () {
      this.loadMyPedigrees();
    },
    mounted: function () {
      this.loadMyPedigrees();
    },
    computed: {
      userInfo(): UserInfo {
        return this.$store.state.userInfo;
      },
      reportViewer(): any {
        return this.$refs.reportViewer;
      }
    },
    watch: {      
      userInfo: function (newVal: object) { 
        this.loadMyPedigrees();
      },    
      "searchParams.includeInactive": { 
        handler: debounce(0,  function(this: any, newValue, oldValue){ this.loadMyPedigrees();})            
      },      
      "searchParams.dogId": {         
        handler: debounce(1000,  function(this: any, newValue, oldValue){ this.loadMyPedigrees();})        
      },       
      "searchParams.dogName": {         
        handler: debounce(1500,  function(this: any, newValue, oldValue){ this.loadMyPedigrees();})        
      },    
    },
    methods: {
      loadMyPedigrees: async function()  {
        this.loading = true;

      const { page, itemsPerPage } = this.options;
      try {
        const response = await pedigreeService.listMyPedigrees(
          this.userInfo.personId,
          { ...this.options,
            page: (page ?? 1) - 1,
            itemsPerPage: itemsPerPage ?? 10 }
          ,
          { ...this.searchParams, personId: this.userInfo.personId }
        );

          this.loading = false;
          this.paginatedResponse = response;
        } catch (ex: any) {
          console.log(ex.response.data.errors)

          this.loading = false;
          this.isError = true;
          
          const descriptiveMessage = ex.response.data.errors
            ? `Error(s): ${Object.values(ex.response.data.errors).join(" & ")}`
            : null

          this.errorMessage = descriptiveMessage ?? ex.message ?? "Unknown error occurred when retrieving data.";
        } finally{
          this.loading = false;
        }
      },
      showReport: function (dogId: string, reportType: number){
          if(lookupsService.isDogReportTypePedigree(reportType)){
            this.Report_Name = "Asca.Api.Reports.rpt3240_Dog_Pedigree_Report_New2.rdlx";
            this.Report_URL = `/reports/pedigree/${encodeURIComponent(dogId.trim())}`;
          } else if (lookupsService.isDogReportTypeProgeny(reportType)) {
            this.Report_Name = "Asca.Api.Reports.rpt3250_Dog_Progeny_Report.rdlx";
            this.Report_URL = `/reports/progeny/${encodeURIComponent(dogId.trim())}`;
          }
          this.openedDogId = dogId
          this.openedReportType = reportType;
          
          this.showReportDialog = true;
        },  
      downloadReport(dogId: string, reportType: number){
          let fileName = formatDateISO(new Date().toISOString()); 
          if(lookupsService.isDogReportTypePedigree(reportType)){
            fileName = `${fileName}_Pedigree_${dogId.trim()}`;
          } else if (lookupsService.isDogReportTypeProgeny(reportType)) {
            fileName = `${fileName}_Progeny_${dogId.trim()}`;
          }
                    
          this.reportViewer.exportToPdf(fileName);                
        },  
    }
  });
  